const RsaSign = require('jsrsasign');
const CryptoJS = require('crypto-js');
// const SignedXml = require('xml-crypto').SignedXml;

export default class CryptoService {

    /**
     * Sign message with the RSA private key
     */
    static signMessage(message, privateKey) {
        const rsa = new RsaSign.RSAKey();
        rsa.readPrivateKeyFromPEMString(privateKey);
        let signature = rsa.sign(message, 'sha256').toUpperCase();
        return signature
    }

    /**
     * Get IIC out of the IICSignature
     */
    static getIIC(iicSignature) {
        let md5Hash = CryptoJS.MD5(CryptoJS.enc.Hex.parse(iicSignature));
        return md5Hash.toString().toUpperCase();
    }

    // /**
    //  * Sign the XML Document
    //  */
    // signXml(xml, privateKey, certificate) {
    //     if(!certificate) {
    //         return null
    //     }

    //     var sig = new SignedXml()
    //     sig.signingKey = privateKey;
    //     sig.signatureAlgorithm = 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256'
    //     sig.canonicalizationAlgorithm = 'http://www.w3.org/2001/10/xml-exc-c14n#'
    //     sig.addReference(
    //         "//*[@Id='Request']", 
    //         ['http://www.w3.org/2000/09/xmldsig#enveloped-signature', 'http://www.w3.org/2001/10/xml-exc-c14n#'],
    //         ['http://www.w3.org/2001/04/xmlenc#sha256'],
    //     )

    //     function CustomKeyInfoProvider(X509Certificate) {
    //         this.cert = X509Certificate
            
    //         this.getKeyInfo = function(key, prefix) {
    //             prefix = prefix || ''
    //             prefix = prefix ? prefix + ':' : prefix
    //             return '<' + prefix + 'X509Data>' +
    //                 '<X509Certificate>' + this.cert + '</X509Certificate>' +
    //                 '</' + prefix + 'X509Data>'
    //         }

    //         this.getKey = function(keyInfo) {
    //             return this.cert
    //         }
    //     }

    //     const X509Certificate = certificate.replace(/-----(BEGIN|END)[\w\d\s]+-----/g, '').replace(/[\r\n]/g, '');
    //     sig.keyInfoProvider = new CustomKeyInfoProvider(X509Certificate)
        
    //     sig.computeSignature(xml, {
    //         // This will place the signature as the last element of the element with Id=Request
    //         location: { reference: "//*[@Id='Request']/*[last()]", action: 'after' } 
    //     })
        
    //     return sig.getSignedXml()
    // }

    /**
     * Get MD5 hash of the provided string
     */
     static md5(str) {
        let md5Hash = CryptoJS.MD5(str);
        return md5Hash.toString().toUpperCase();
    }
}
